import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import logoWhite from '../Assets/logo-white.svg'
const Footer: React.FC = () => {
  return (
    <footer style={{ backgroundColor: '#0B1442', color: 'white', padding: '20px 0' }}>
      <Container fluid>
        <Row className="align-items-center">
          {/* Logo y Botón Newsletter */}
          <Col md={1} className="d-flex align-items-start flex-column"></Col>
          <Col md={7} className="d-flex align-items-start flex-column">
            <img src={logoWhite} alt="" />
            <div className="d-flex flex-column">
              <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>GRAY DI</span>
              <Button variant="primary" style={{ marginTop: '10px', backgroundColor: '#89CFF0', border: 'none' }}>
                Newsletter
              </Button>
            </div>
          </Col>

          {/* Atajos */}
          <Col md={2}>
            <h6>Shortcuts</h6>
            <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
              <li>
                <a href="#" style={{ color: 'white', textDecoration: 'none' }}>Documentations</a>
              </li>
              <li>
                <a href="#" style={{ color: 'white', textDecoration: 'none' }}>Guides</a>
              </li>
              <li>
                <a href="#" style={{ color: 'white', textDecoration: 'none' }}>Product Updates</a>
              </li>
              <li>
                <a href="#" style={{ color: 'white', textDecoration: 'none' }}>Case Studies</a>
              </li>
              <li>
                <a href="#" style={{ color: 'white', textDecoration: 'none' }}>Tickets</a>
              </li>
              <li>
                <a href="#" style={{ color: 'white', textDecoration: 'none' }}>Back to portal</a>
              </li>
            </ul>
          </Col>

          {/* Contacto */}
          <Col md={2}>
            <h6>Contact Us</h6>
            <p>
              <i className="fas fa-phone-alt" /> 617-366-2838
            </p>
            <p>
              <i className="fas fa-envelope" /> info@graydi.us
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
